<template>
  <div v-show="vg_modal">
    <!--Signup modal start -->
    <div class="modal signup-modal modal-fullscroll is-active">
      <div class="modal-background"></div>
      <div class="modal-card is-small">
        
        <header class="modal-card-head">
          <button class="delete" @click.prevent="closeModal()" aria-label="close"></button>
          <p class="modal-card-title has-text-black pb10">Sign Up</p>	
          <p class="is-size-16 full-width has-text-black mt20 has-text-centered has-text-weight-semibold" v-if="screen == 2">Almost there!</p>		
        </header>
        
        <section class="modal-card-body ph20">

          <div class="text-center" v-if="signup_business_logo && screen == 1">
            <img :src="signup_business_logo" alt="" class="signup-modal-business-logo"/>
              <div class="bg-primary text-white mt-5 pa-8 mb-15 border-radius-4 is-size-16px" v-if="vg_businessLoyality && vg_businessLoyality.name">
                Become a VIP with <em class="text-white has-text-weight-semibold font-normal">{{ vg_businessLoyality.name }}</em> and earn rewards and perks!
              </div>
          </div>
          
          <ValidationObserver ref="val_observer">
          <form ref="screen_1" v-show="screen == 1">
            
            <div class="social-login" v-if="!signupTypeSocial && !guestUserFromBudtenderSignup">
              <div class="social-icons-wrap is-flex is-flex-column">
                <div id="buttonDiv"></div>
                <a href="#" class="social-login-signup-wrapper mb10" @click.prevent="signupWithGoogle">
                  <div class="social-login-section">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="20" viewBox="0 0 18 18" aria-hidden="true"><title>Google</title><g fill="none" fill-rule="evenodd"><path fill="#4285F4" d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7959 2.7164v2.2581h2.9087c1.7018-1.5668 2.6836-3.874 2.6836-6.615z"></path><path fill="#34A853" d="M9 18c2.43 0 4.4673-.806 5.9564-2.1805l-2.9087-2.2581c-.8059.54-1.8368.859-3.0477.859-2.344 0-4.3282-1.5831-5.036-3.7104H.9574v2.3318C2.4382 15.9832 5.4818 18 9 18z"></path><path fill="#FBBC05" d="M3.964 10.71c-.18-.54-.2822-1.1168-.2822-1.71s.1023-1.17.2823-1.71V4.9582H.9573A8.9965 8.9965 0 0 0 0 9c0 1.4523.3477 2.8268.9573 4.0418L3.964 10.71z"></path><path fill="#EA4335" d="M9 3.5795c1.3214 0 2.5077.4541 3.4405 1.346l2.5813-2.5814C13.4632.8918 11.426 0 9 0 5.4818 0 2.4382 2.0168.9573 4.9582L3.964 7.29C4.6718 5.1627 6.6559 3.5795 9 3.5795z"></path></g></svg>
                    <span class="letter-space-0_5 is-size-14">SIGN UP WITH GOOGLE</span>
                  </div>
                </a>
                <a href="#" class="social-login-signup-wrapper" @click.prevent="signupWithFacebook">
                  <div class="social-login-section">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="20" viewBox="0 0 24 24"><path  fill="#4285F4" d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg>
                    <span class="letter-space-0_5 is-size-14">SIGN UP WITH FACEBOOK</span>
                  </div>
                </a>
              </div>
              <div class="mt20 mb20 is-size-14"><span>Or continue with:</span></div>
            </div>

            <div class="signup-modal-fields">
              <div class="columns is-variable is-1-tablet is-multiline">
                <div class="column is-12-mobile is-12-tablet is-6-widescreen is-6-desktop pb0">
                  <div class="field">
                    <div class="control">
                      <validation-provider name="first name" ref="signup_first_name" rules="required">
                        <template #default="{ errors }">
                          <input
                            class="input"
                            name="first name"
                            v-model="form.first_name"
                            type="text"
                            placeholder="First Name*"
                          />
                          <span class="validation-error">{{ errors[0] }}</span>
                        </template>
                      </validation-provider>
                    </div>
                  </div>
                </div>
                <div class="column is-12-mobile is-12-tablet is-6-widescreen is-6-desktop pb0">
                  <div class="field">
                    <div class="control">
                      <validation-provider name="last name" ref="signup_last_name" rules="required">
                        <template #default="{ errors }">
                          <input
                            class="input"
                            name="Last Name"
                            v-model="form.last_name"
                            type="text"
                            placeholder="Last Name*"
                          />
                          <span class="validation-error">{{ errors[0] }}</span>
                        </template>
                        </validation-provider>
                    </div>
                  </div>
                </div>
                
                <div class="column is-12-mobile is-12-tablet is-12-widescreen is-12-desktop pb0 mb10" v-show="!signupTypeSocial">
                  <div class="field">
                    <div class="control">
                      <validation-provider name="email" ref="signup_email" rules="required|email"> 
                      <template #default="{ errors }">
                        <input
                           :class="'input' + (guestUserFromBudtenderSignupType == 'email' ? ' pointer-none_' : '')"
                          name="Email"
                          v-model="form.email"
                          type="email"
                          placeholder="Email*"
                        />
                        <span class="validation-error">{{ errors[0] }}</span>
                      </template>
                    </validation-provider>
                    <p class="is-size-11 mt5">Make sure your email is correct, it has to be verified in order to fully register your account</p>
                    </div>
                  </div>
                </div>
                
                <div class="column is-12-mobile is-12-tablet is-12-widescreen is-12-desktop pb0">
                  <div class="field">
                    <div class="control">
                      <validation-provider name="phone" ref="signup_phone" rules="phone_number_only_if_has_value"><!--  rules="required|phone_number|numeric"-->
                        <template #default="{ errors }">
                          <input
                            :class="'input hide-arrow' + (guestUserFromBudtenderSignupType == 'phone' ? ' pointer-none_' : '')"
                            name="phone"
                            v-model="form.phone"
                            type="number"
                            onkeydown="if(event.key==='.'){event.preventDefault();}"
                            placeholder="Phone Number"
                          />
                          <span class="validation-error">{{ errors[0] }}</span>
                        </template>
                      </validation-provider>
                    </div>
                  </div>
                </div>

                <div class="column is-12-mobile is-12-tablet is-12-widescreen is-12-desktop pb0" v-if="signupTypeSocial">
                  <p class="is-size-14">Email: {{ form.email }}</p>
                </div>

                <div class="column is-12-mobile is-12-tablet is-12-widescreen is-12-desktop mb10">
                  <div class="field mt20 mb10 checkout-offers">
                    <input class="is-checkradio" v-model="form.marketing_notification" id="signupOptIn" type="checkbox" name="signupOptIn" :value="1">
                    <label for="signupOptIn" class="has-text-black is-size-12">I want to receive new offers & discounts!</label>
                  </div>
                </div>
              
              </div>
            </div>
          </form>
          </ValidationObserver>

          <div v-show="screen == 2">
            <div class="text-center">
              <p class="is-size-14 mb10">We have sent you a confirmation link to <strong>{{ form.email }}</strong>.</p>
              <p class="is-size-14 mb20">You will be good to go as soon as its been verified!</p>
            </div>
          </div>
        </section>

        <footer class="modal-card-foot">
          <div class="column p0">
            <template v-if="screen == 1">
              <button type="button" @click="signUpNow()" class="button is-large bg-secondary text-white hover-opacity-7 is-full-width">Continue</button>
              <p class="is-size-11 has-text-centered mt10">By pressing “Continue” you automatically agree to Budler <router-link target="_blank" :to="{ name: 'TermsConditions', params: { business_slug: $route.params.business_slug }, query: $route.query}">Terms & Conditions</router-link>  and <router-link target="_blank" :to="{ name: 'PrivacyPolicy', params: { business_slug: $route.params.business_slug }, query: $route.query}">Privacy Policy</router-link>.</p>
              <p class="is-size-14 has-text-centered mb20 mt20">Already have an account? <a href="#" @click.prevent="signInscreen()" class="text-secondary hover-text-secondary hover-opacity-8 has-text-weight-semibold  is-underlined">CLICK HERE</a></p>
            </template>
            <div class="text-center">
              <p class="has-text-centered has-text-weight-medium is-size-11 text-primary mb10">POWERED BY <img class="powered-logo" alt="logo" src="@/assets/img/logo.png" /></p>
            </div>
          </div>
        </footer>
        
      </div>
    </div>
    <!--Signup modal ends -->
  </div>
</template>

<script>
import Env from '@/env';
import { mapGetters, mapActions } from 'vuex';
import Helpers from '@/Components/Helpers/Helpers';
import moment from 'moment';
import SignupApis from '@/Components/Controllers/SignupApis';
import UserApis from '@/Components/Controllers/UserApis';
import VboutApis from '@/Components/Controllers/VboutApis';
import OrderHistoryApis from '@/Components/Controllers/OrderHistoryApis';
import CartApis from '@/Components/Controllers/CartApis';
import GuestUserApis from '@/Components/Controllers/GuestUserApis';

export default {
  name: 'SignupModal',
  data() {
    return {
      signupTypeSocial: false,
      guestUserFromBudtenderSignup: false,
      guestUserFromBudtenderSignupType: '',
      submit: false,
      screen: 1,
      form: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        marketing_notification: 0,
        redirect_url: '',
        social_type: '',
        social_id: '',
        // Need to add 
        business_id: '',
        business_name: '',
        business_slug: '',
        logo_url: '',
        location_id: '',
        location_slug: '',
      },
    };
  },

  watch: {
   
    vg_modal(val){
      if(!val){
        Helpers.removeFbCookeFromLocal();
      } else {
        // has value trigger
       // this.budtenderGusetSignup();
      }
    },

    form: {
      handler: function () {
        if(this.form.social_type && this.form.social_id){
          this.signupTypeSocial = true;
        } else {
          this.signupTypeSocial = false;
        }
      },
      deep: true
    },

    'form.phone'(val){
      if(val){
        if(val.indexOf(".") != -1) {
          this.form.phone = val.replace(/\./g,"");
        }
        let newval = val.trim();
        if(val.length > 10){
          newval = newval.slice(0,10)
        } 
        this.form.phone = newval;
      }
    },
    'form.first_name'(val){
      this.form.first_name = val ? val.trim() : '';
    },
    'form.last_name'(val){
      this.form.last_name = val ? val.trim() : '';
    },
    'form.email'(val){
      this.form.email = val ? val.replaceAll(/\s/g,'').toLowerCase().trim() : '';
    }
  },
  computed: {

    ...mapGetters({
      vg_modal: 'signupmodal/modal',
      vg_userId: "getLoggedInUserId",
      vg_businessProfile: "businessprofile/detail", 
      vg_selectedStore: "location/selected", 
      vg_businessLoyality: "businessprofile/businessLoyality",
      vg_cartItems: "cart/cartItems",
      vg_outOfStockPendingItem: "outofstocksubscriptions/pendingItem",
    }),

    signup_business_logo() {
      // Show business loyalty logo if available else business logo
      if(!_.isEmpty(this.vg_businessLoyality)  && this.vg_businessLoyality.branding && this.vg_businessLoyality.branding.logo_url) {
        return this.vg_businessLoyality.branding.logo_url;
      } else if(!_.isEmpty(this.vg_businessProfile)  && this.vg_businessProfile.branding && this.vg_businessProfile.branding.logo_url) {
        return this.vg_businessProfile.branding.logo_url;
      } else {
        return '';
      }
    },

  },

  async mounted() {
    this.va_setModal(false);
    await Helpers.loadFacebookSDK();
    await Helpers.initFacebook(this.vg_userId);
    bus.$on('social-data-pass-to-signup', (payload) => {
      // on login form social is invalid so passed here to signup
      this.signupTypeSocial = true;
      this.form = {
        first_name: payload.user.first_name,
        last_name: payload.user.last_name,
        email: payload.user.email,
        phone: '',
        marketing_notification: 0,
        redirect_url: '',
        social_type: payload.user.social_type,
        social_id: payload.user.social_id,
        // Need to add
        business_id: '',
        business_name: '',
        business_slug: '',
        logo_url: '',
        location_id: '',
        location_slug: '',
      };
      this.va_setModal(true)
    })

    // get data
    this.budtenderGusetSignup();
   
  },

  beforeDestroy() {
    bus.$off('social-data-pass-to-signup');
  },

  methods: {
    /**
     * Get user detail from token for budtender guest signup
     */
    async budtenderGusetSignup() {
       // If user has signup_token, signup true and not loggedin then fetch data from api and fill in 
      if( !this.vg_userId && ((this.$route.query.signup == 'true') || (this.$route.query.signup == 1)) && this.$route.query.signup_token ){
        let guestRes = await GuestUserApis.getGuestDetails(this.$route.query.signup_token);
        if(guestRes.status == 200) {
          this.guestUserFromBudtenderSignup = true;
          this.form.first_name = guestRes.data.payload.first_name;
          this.form.last_name =  guestRes.data.payload.last_name;
          this.form.email = guestRes.data.payload.email;
          this.form.phone = guestRes.data.payload.phone;
          // lets overide from above
          if(guestRes.data.payload.guest_token_data && guestRes.data.payload.guest_token_data.value_type){
            this.guestUserFromBudtenderSignupType = guestRes.data.payload.guest_token_data.value_type;
            if(guestRes.data.payload.guest_token_data.value_type == 'phone'){
              this.form.phone = guestRes.data.payload.guest_token_data ? guestRes.data.payload.guest_token_data.new_value : '';
            } else if(guestRes.data.payload.guest_token_data.value_type == 'email'){
              this.form.email = guestRes.data.payload.guest_token_data ? guestRes.data.payload.guest_token_data.new_value : '';
            }
          }
          this.form.marketing_notification = guestRes.data.payload.marketing_notification;
        } else {
          this.guestUserFromBudtenderSignup = false;
        }
      }
    },


    /**
     * Signup age verification
     */
    async signUpNow() {
      let validation = await Helpers.validateRefs(this, ['signup_first_name', 'signup_last_name', 'signup_email', 'signup_phone']);
      if( validation ) {
        
        // we used to pass signup
        // Note : we used to pass signup auth when user verify email and autologin, now we need to get back on signup page
        // with token and verify_email=true passed from backend
        //this.form.redirect_url = window.location.href; // window.location.protocol + '//' + window.location.host + this.$route.path;
        // handle redirect at last,Some query might needed so use filter
        let query = Helpers.refineQuery(['token', 'verify_email', 'source', 'signup_token', 'signup', 'kiosk'], _.clone(this.$route.query));
        query = new URLSearchParams(query).toString();
        query = query ? '?' + query : '';
        this.form.redirect_url = window.location.protocol + '//' + window.location.host + this.$route.path + query;

        this.va_spinner(true)
        let obj = _.clone(this.form);
        if(!this.signupTypeSocial){
          delete obj['social_type'];
          delete obj['social_id'];
        }
         // If source present on url 
        if(this.$route.query.source) {
          obj.registered_from = this.$route.query.source;
        }
        if(this.$route.query.signup_token) {
          obj.guest_token = this.$route.query.signup_token;
        }

        // Need to Add
        obj.business_id = this.vg_businessProfile.id;
        obj.business_name = this.vg_businessProfile.name;
        obj.business_slug = this.$route.params.business_slug;
        obj.logo_url = (this.vg_businessProfile && this.vg_businessProfile.branding && this.vg_businessProfile.branding.logo_url) ? this.vg_businessProfile.branding.logo_url : '';
        obj.location_id = this.vg_selectedStore.id ? this.vg_selectedStore.id : '';
        obj.location_slug = this.vg_selectedStore.slug ? this.vg_selectedStore.slug : '';
      
        let res = await SignupApis.passwordLessSignup(obj);
        this.va_snackbar({
          type: res.status == 201 ? 'success' : 'warning',
          message: res.status == 201 ? res.data.msg : res.response.data.msg,
        });

        if(res.status == 201){
          // Push user to vbout
          let vboutAddUser = await VboutApis.upsertUser(res.data.payload, this.vg_selectedStore.id);
          if(vboutAddUser && (vboutAddUser.status == 201) ){
            const promise1 = res.data.payload.marketing_notification ? VboutApis.addUserTag({
                email: res.data.payload.email,
                tagname: 'casl_opt_in',
              }, this.vg_selectedStore.id) : false;
            
            const promise2 = res.data.payload.email_verification_status ? VboutApis.addUserTag({
                email: res.data.payload.email,
                tagname: 'verified',
              }, this.vg_selectedStore.id) : false;

            // trigger once to save time 
            await Promise.all([promise1, promise2]).then((values) => {
              // Dont need result just need to trigger
            });
          }
          this.va_spinner(false)
          this.$refs.val_observer.reset();
          // if business has loyality programme
          // if(this.vg_businessLoyality.id){
          //   // Here we need to push user on loyality programme
          //   bus.$emit('show-modal-loyality-signup', {
          //     modal: true,
          //     user: res.data.payload
          //   })
          // }
          // if user did social signup
          if(this.signupTypeSocial || res.data.payload.token){
            // then make user logged in close this modal 
            this.va_spinner(true);
            await this.setLoginSuccessUserData(res)
            this.va_spinner(false);
            this.closeModal();
          } else {
            this.va_spinner(false);
            this.screen = 2;
          }
        } else {
          this.va_spinner(false)
        }
      }
    },

    /**
     * Signup with facebook
     */
    signupWithFacebook() {
      const self = this;
      //self.va_spinner(true);
      window.FB.login(async function(response) {
        if (response.authResponse) {
          await window.FB.api('/me', { 
            locale: 'en_US', 
            fields: 'id,first_name,last_name,email,link,gender,locale' 
          }, function(fbData){
            self.va_spinner(false);
            if (fbData.id) {
              self.form.first_name = fbData.first_name;
              self.form.last_name = fbData.last_name;
              self.form.email = fbData.email;
              self.form.social_type = 'facebook';
              self.form.social_id = response.authResponse.userID;
            } else {
              self.va_snackbar({
                type: 'warning',
                message: 'Unable to fetch facebook detail.',
              });
            }
          });      
        } else {
          self.va_spinner(false);
          // self.va_snackbar({
          //   type: 'warning',
          //   message: 'User cancelled login or did not fully authorize.',
          // });
        }
      }, { 
        scope: 'public_profile,email'
      });
      return false;
    },

    /**
     * Signup with google
     */
    signupWithGoogle() {
      const self = this;
      this.va_spinner(true);
      this.$gAuth
        .signIn()
        .then( async (GoogleUser) => {
          let googleProfile = GoogleUser.getBasicProfile();
          self.form.first_name = googleProfile.getGivenName();
          self.form.last_name = googleProfile.getFamilyName();
          self.form.email = googleProfile.getEmail();
          self.form.social_type = 'google';
          self.form.social_id = GoogleUser.getId();
          this.va_spinner(false);
        })
        .catch(error => {
          this.va_spinner(false);
          console.log('error', error)
        })
    },

    /**
     * on success login set datas
     */
    async setLoginSuccessUserData(res) {
      const self = this;
        
      // Add user location on login
      if(this.vg_selectedStore.id){
        UserApis.addUserLocation(res.data.payload.id, this.vg_selectedStore.id, this.$route.query);
      }

      // Reset login form 
      this.$store.dispatch("SET_USER_TOKEN", res.data.payload.token);
      this.$store.dispatch("SET_USER_DETAILS", res.data.payload);
      this.$store.dispatch("SET_USER_LOGGEDIN_DATE", moment().format('YYYY-MM-DD HH:mm:ss'));

      // Start loyalty stuffs only if business is active
      if(this.vg_businessLoyality.id && this.vg_businessLoyality.is_active) {
        // If not setup try it, signup hits loyality in it
        let loyaltyJoinRes = await this.va_joinUserOnLoyalityProgram({
          user_id: res.data.payload.id,
          business_id: this.vg_businessProfile.id,
          referral_key: this.$route.query.referral_key ? this.$route.query.referral_key : '', // if has ref key pass it 
        })

        // For signup bonus
        if( (loyaltyJoinRes.status == 201) && (loyaltyJoinRes.data.payload.welcome_bonus > 0) ) {
          // show loyalty bonus point for signup
          bus.$emit('loyality-signup-congratulations', {
            modal: true,
            point: loyaltyJoinRes.data.payload.welcome_bonus,
            message: "Sign Up Bonus!",
          })
        }

        // For referral bonus
        if( (loyaltyJoinRes.status == 201) && (loyaltyJoinRes.data.payload.referral_bonus > 0) ) {
          // show loyalty bonus point for signup
          bus.$emit('loyality-referral-congratulations', {
            modal: true,
            point: loyaltyJoinRes.data.payload.referral_bonus,
            message: "A little something for being referred!",
          })
        }

        // user loyality checkin only if in_store, social signup mean their emial verified no need to check verified
        if((this.$route.query.in_store == 1) || (this.$route.query.in_store == 'true')){
          let userCheckInres = await UserApis.userLoyalityCheckIn(this.vg_businessProfile.id, this.vg_selectedStore.id, this.vg_selectedStore.name);
          if(userCheckInres.status == 200){
            // alert modal
            bus.$emit('loyality-checkin-congratulations', {
              modal: true,
              point: userCheckInres.data.payload.points_earned,
              message: "You've checked in!",
            })
          }
        }

        // Get user loyalty
        this.va_setUserLoyalityObj({
          user_id: res.data.payload.id, 
          business_id: this.vg_businessProfile.id
        });

      }

      // fetch order, for signup user dont have history so we can close call
      // let orderHistory = await OrderHistoryApis.fetch(1);
      // fetch user fav location
      // UserApis.fetchFavLocations();
      // fetch user fav products
      // UserApis.fetchFavProducts();

      // as soon as user logged in remove guest checkout params
      // this.va_setGuestLandedQueries({})
      // if we have selected store fetch that store cart items 
      if(!_.isEmpty(this.vg_selectedStore) && this.vg_selectedStore.id != ''){
        
        if(this.vg_cartItems.length == 0){
          // Fetch cart is guest doesnot have any cart
          await CartApis.locationCart(this.vg_selectedStore.id, Helpers.getLocationCartFullUrl(this));
        } else {
          // Fetch and merge guest and user cart
          await CartApis.convertGuestCartToUserCart(Helpers.getLocationCartFullUrl(this));
        }

        // Ask for cart loyalty preview
        await this.va_setCartLoyalityPointsObj({
          order_receive_method: 'pickup'
        });
        
        // After login push cart item on vbout but before that clear cart
        // First clear vbout cart, at first just signup user dont have pushed cart
        // Add product one by one
        if(this.vg_cartItems && this.vg_cartItems.length > 0){
          this.vg_cartItems.forEach(async (item) => {
            await VboutApis.addCartItem(item, Helpers.getLocationProductFullUrl(self, item.product_id), self.vg_selectedStore.id);
          })
        }
      }

      // lets see if we have any pending item for cart, if yes 
      if(!_.isEmpty(this.vg_pendingItemOnCart)) {
        // we have pending item
        bus.$emit('listen-pending-cart-item', this.vg_pendingItemOnCart);
        // once emit make it balnk
        this.va_setPendingItem({});
      }
      // if(orderHistory.status == 200) {
      //   this.va_setAllOrders(orderHistory.data.payload);
      // }
    
      this.va_spinner(false);
      this.closeModal();

       // Now lets see if we are coming outofstock pending item
      if(!_.isEmpty(this.vg_outOfStockPendingItem)) {
        bus.$emit('variant-out-of-stock-notification', {
          modal: true,
          variant: this.vg_outOfStockPendingItem,
        })
      }

      // This modal closes then
      // if( (userLoyality.status != 200) && (this.vg_businessLoyality.id) ){
      //   // please do not show loyality signup modal in checkout because this page has inline
      //   if(this.$route.name != 'Checkout'){
      //     // Send an emit to signup on loyality program
      //     bus.$emit('show-modal-loyality-signup', {
      //       modal: true,
      //       user: res.data.payload
      //     })
      //   }  
      // }

      // lets vg_ if we have vg_ after login
      if(!_.isEmpty(this.$store.getters.getLoggedInUserRedirect)){
        // now lets vg_
        if(_.isEmpty(this.vg_pendingItemOnCart)) {
          this.$router.push(this.$store.getters.getLoggedInUserRedirect);
        }
      }
    },

    

    /**
     * Close modal
     */
    closeModal() {
      this.form = {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        marketing_notification: 0,
        redirect_url: '',
      }; // hard coded to escape social added keys
      this.$refs.val_observer.reset();
      this.va_setModal(false);
      this.screen = 1;
      this.submit = false;
    },

    /**
     * get login screen
     */
    signInscreen() {
      this.closeModal();
      this.va_setLoginModal(true);
    },

    ...mapActions({
      va_setGuestLandedQueries: "location/setGuestLandedQueries",
      va_setPendingItem: "cart/setPendingItem",
      va_setAllOrders: "orderhistory/setAllOrders",
      va_setUserLoyalityObj: "userloyalitysubscription/setUserLoyalityObj",
      va_setLoginModal: "loginmodal/setModal",
      va_setModal: 'signupmodal/setModal',
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_joinUserOnLoyalityProgram: "userloyalitysubscription/joinUserOnLoyalityProgram",
      va_setCartLoyalityPointsObj: "cart/setLoyalityPointsObj",
    }),
  },
};
</script>
<style scoped>
.text-center{
  text-align:center
}
.day-month-year-picker p{
    font-size: 12px;
    padding: 8px 12px;
    padding-bottom: 0;
}
 .day-month-year-picker select{
    height: 35px;
    padding-top: 0;
    padding: 8px 12px;
    padding-right: 0px !important;
    padding-top: 0px;
}
.is-full-width.pr-5 {
    padding-right: 25px;
}
.mb-2{
  margin-bottom: 20px;
}
.is-required{
  padding-left: 0px;
}
.province {
  padding: 8px;
  font-size: 12px;
  margin-bottom: 0;
  padding-bottom: 0;
}
select.province-select {
  position: relative;
  top: -5px;
}
</style>